module.exports = __webpack_public_path__ + "img/weight-warning.ca87583a.svg";